import LoginEmpresa from 'core/views/LoginEmpresa.vue'
import Lembrar from 'core/views/Lembrar.vue'
import Alterar from 'core/views/Alterar.vue'

export default [
  {
    title: 'Início ',
    icon: 'fas fa-home',
    path: '/home',
    menu: true,
    home: true,
    dir: 'views/',
    view: 'Home',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master']
    }
  },
  {
    title: 'Propostas',
    path: '/propostas',
    menu: true,
    dir: 'views/',
    view: 'PropostaList',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master']
    }
  },
  {
    path: '/',
    title: 'Login',
    menu: false,
    dir: 'views/',
    view: 'Login',
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/lembrar',
    component: Lembrar,
    default: true,
    title: 'Lembrar Senha',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/recuperar',
    component: Alterar,
    default: true,
    title: 'Alterar Senha',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/parceiro',
    component: LoginEmpresa,
    title: 'Login Empresa',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  }
]
